enum SqlOperator {
  BETWEEN = 'BETWEEN',
  EQ = 'EQ',
  GT = 'GT',
  GTE = 'GTE',
  IN = 'IN',
  IS_NOT_NULL = 'IS_NOT_NULL',
  IS_NULL = 'IS_NULL',
  LIKE = 'LIKE',
  LT = 'LT',
  LTE = 'LTE',
  NEQ = 'NEQ',
  NOT_BETWEEN = 'NOT_BETWEEN',
  NOT_IN = 'NOT_IN',
  NOT_LIKE = 'NOT_LIKE',
}
export default SqlOperator;
